import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { classMap as o } from '../../../../node_modules/lit-html/directives/class-map.js';
import '../../../../node_modules/lit-media-query/lit-media-query.js';
import { imgLazyLoadingResolver } from '../../../common/img-lazy-loading-resolver.js';
import { property as n } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { metricsTrack } from '../../utilities/analytics/index.js';
import { isSameOrigin } from '../../utilities/backend-helpers/index.js';
import { scrollIntoView, triggerExternalLinkPopup } from '../../utilities/behavior-helpers/index.js';
import { setDataAttributes } from '../../utilities/dom-helpers/index.js';
import { setLineClamp, lineClamp } from '../../../generated/global-content/components/utilities/text-helpers/index.js';
import { ifDefined as l } from '../../../../node_modules/lit-html/directives/if-defined.js';
import css_248z$1 from '../../typography/headings/card-heading/card-heading.scss.js';
import css_248z$3 from './styles/groupsite-category-tile-small.scss.js';
import css_248z$2 from '../../typography/texts/card-text/card-text.scss.js';
import css_248z from './styles/category-tile-small.scss.js';
import { TileStyleTypes, TileTypes } from './types.js';

const containerClassName = '.small-tile-container';
const simpleCardHeadingCharLimit = 48;
class CategoryTileSmall extends s {
    constructor() {
        super();
        this.disableImage = false;
        this.simpleCard = false;
        this.slimCard = false;
        this.isBurgundyMobile = false;
        this.styleType = TileStyleTypes.LIGHT;
        this.size = TileTypes.REGULAR;
        this.isGroupsite = false;
        this.hideDescription = false;
        this.templateType = 'classic';
        this.textAlign = 'left';
        this.enableShadow = false;
        this.headerSize = 'medium';
        this.ctaType = 'primary';
        this.headingSlot = null;
        this.textSlot = null;
        this.externalLinkPopup = null;
        this.renderImageBlock = () => x `<div class="image ${this.disableImage ? 'hidden' : ''}"><slot name="background-image" @slotchange="${this.handleSlotChange}"></slot></div>`;
        this._query = '(max-width: 767px)';
        this._isMobile = false;
    }
    _handleMediaQuery(event) {
        this._isMobile = event.detail.value;
        this.requestUpdate();
    }
    handleFocus() {
        scrollIntoView(this, document.querySelector('.container > .top'), 50);
    }
    handleClick(e) {
        const target = e.target;
        const url = this.renderRoot.querySelector(containerClassName).href;
        const isOutbound = !isSameOrigin(url);
        triggerExternalLinkPopup(e, this);
        metricsTrack('cevt_link_click', {
            dlv_event_category: 'link',
            dlv_event_action: `outbound ${isOutbound}`,
            dlv_link_outbound: isOutbound,
            dlv_link_hostname: new URL(url).hostname,
            dlv_link_element: target,
            dlv_link_classes: target.getAttribute('class'),
            dlv_link_text: target.textContent,
            dlv_link_url: url,
        });
    }
    static flattenSupElements(container) {
        function moveNestedSups(sup) {
            const nestedSups = sup.querySelectorAll('sup');
            nestedSups.forEach(nestedSup => {
                while (nestedSup.firstChild) {
                    sup.appendChild(nestedSup.firstChild);
                }
                nestedSup.remove();
            });
        }
        let hasNested = true;
        const handleSup = (supElements) => {
            supElements.forEach((sup) => {
                const nestedSups = sup.querySelectorAll('sup');
                if (nestedSups.length > 0) {
                    hasNested = true;
                    moveNestedSups(sup);
                }
            });
        };
        while (hasNested) {
            hasNested = false;
            const supElements = container.querySelectorAll('sup');
            handleSup(supElements);
        }
    }
    static handleRegisterSign() {
        const headingTag = document.querySelector('.card-heading');
        if (!headingTag)
            return;
        const headingText = headingTag.innerHTML;
        if (headingText === null || headingText === void 0 ? void 0 : headingText.includes('®')) {
            const newHeading = headingText.replace(/®/g, '<sup>®</sup>');
            headingTag.innerHTML = newHeading;
        }
        CategoryTileSmall.flattenSupElements(headingTag);
    }
    setTabIndexAttributeForCarousels() {
        const parent = this.parentElement;
        if (!(parent === null || parent === void 0 ? void 0 : parent.classList.contains('swiper-slide')))
            return;
        const card = this.shadowRoot.querySelector(containerClassName);
        if (parent === null || parent === void 0 ? void 0 : parent.classList.contains('swiper-slide-duplicate')) {
            card === null || card === void 0 ? void 0 : card.setAttribute('tabindex', '-1');
        }
        else {
            card === null || card === void 0 ? void 0 : card.setAttribute('tabindex', '0');
        }
    }
    firstUpdated() {
        var _a;
        CategoryTileSmall.handleRegisterSign();
        (_a = document.querySelector('.fallback-cta')) === null || _a === void 0 ? void 0 : _a.remove();
        this.renderRoot
            .querySelector(containerClassName)
            .addEventListener('click', e => this.handleClick(e), true);
        setDataAttributes(this, 'heading', 'text');
        setLineClamp(this, 80, 120);
        this.setTabIndexAttributeForCarousels();
        const simpleCardHeading = this.simpleCard
            ? this.querySelector('[slot="simple-card-heading"]')
            : null;
        if (simpleCardHeading)
            simpleCardHeading.innerText = lineClamp(simpleCardHeading.innerText, simpleCardHeadingCharLimit);
        const modal = document.querySelector('cvt-modal[popupid="external-link"]');
        if (!modal)
            return;
        this.externalLinkPopup = modal.querySelector('external-link');
        CategoryTileSmall.handleRegisterSign();
    }
    handleSlotChange() {
        imgLazyLoadingResolver(this);
    }
    render() {
        const styleClass = this._isMobile && this.isBurgundyMobile
            ? 'style-burgundy-dark'
            : `style-${this.styleType}`;
        const sizeClass = `size-${this.size}`;
        const renderSimpleCardHeading = () => x `<slot name="simple-card-heading" class="heading"></slot>`;
        const componentClasses = {
            'small-tile-container': true,
            'simple-card': this.simpleCard,
        };
        const cardClasses = {
            'small-tile': true,
            [styleClass]: true,
            [sizeClass]: true,
            slim: this.slimCard,
            'no-image': (!this.backgroundImage || this.disableImage) && !this.simpleCard,
            lighthouse: this.templateType === 'lighthouse',
            shadow: this.enableShadow,
            [`cta-${this.ctaType}`]: true,
            [`text-align-${this.textAlign}`]: true,
        };
        const headerClasses = {
            [`header-size-${this.headerSize}`]: true,
        };
        const renderCardContent = () => x `<slot name="date" class="date"></slot><slot name="tags" class="tags"></slot><slot class="${o(headerClasses)}" name="heading"></slot>${this.hideDescription ? "" : x `<slot name="description"></slot>`}`;
        const renderCta = () => {
            if (this.templateType === 'lighthouse') {
                return x `<slot name="cta"></slot>`;
            }
            return x `<div></div>`;
        };
        return x `<a href="${this.href}" target="${l(this.target)}" @focus="${this.handleFocus}" class="${o(componentClasses)}"><div class="${o(cardClasses)}">${this.backgroundImage ? this.renderImageBlock() : ''}<div class="content">${this.simpleCard ? renderSimpleCardHeading() : renderCardContent()}</div>${renderCta()}</div><lit-media-query .query="${this._query}" @changed="${this._handleMediaQuery}"></lit-media-query></a>`;
    }
}
CategoryTileSmall.styles = [css_248z, css_248z$1, css_248z$2, css_248z$3];
__decorate([
    n({ type: Boolean })
], CategoryTileSmall.prototype, "backgroundImage", void 0);
__decorate([
    n({ type: String })
], CategoryTileSmall.prototype, "href", void 0);
__decorate([
    n({ type: String })
], CategoryTileSmall.prototype, "target", void 0);
__decorate([
    n({ type: String })
], CategoryTileSmall.prototype, "ctaText", void 0);
__decorate([
    n({ type: String })
], CategoryTileSmall.prototype, "heading", void 0);
__decorate([
    n({ type: Object })
], CategoryTileSmall.prototype, "category", void 0);
__decorate([
    n({ type: Boolean })
], CategoryTileSmall.prototype, "disableImage", void 0);
__decorate([
    n({ type: Boolean })
], CategoryTileSmall.prototype, "simpleCard", void 0);
__decorate([
    n({ type: Boolean })
], CategoryTileSmall.prototype, "slimCard", void 0);
__decorate([
    n({ type: Boolean })
], CategoryTileSmall.prototype, "isBurgundyMobile", void 0);
__decorate([
    n({ type: String })
], CategoryTileSmall.prototype, "styleType", void 0);
__decorate([
    n({ type: String })
], CategoryTileSmall.prototype, "size", void 0);
__decorate([
    n({ type: Boolean })
], CategoryTileSmall.prototype, "isGroupsite", void 0);
__decorate([
    n({ type: Boolean })
], CategoryTileSmall.prototype, "hideDescription", void 0);
__decorate([
    n({ type: String })
], CategoryTileSmall.prototype, "templateType", void 0);
__decorate([
    n({ type: String })
], CategoryTileSmall.prototype, "textAlign", void 0);
__decorate([
    n({ type: Boolean })
], CategoryTileSmall.prototype, "enableShadow", void 0);
__decorate([
    n({ type: String })
], CategoryTileSmall.prototype, "headerSize", void 0);
__decorate([
    n({ type: String })
], CategoryTileSmall.prototype, "ctaType", void 0);
__decorate([
    t()
], CategoryTileSmall.prototype, "headingSlot", void 0);
__decorate([
    t()
], CategoryTileSmall.prototype, "textSlot", void 0);
customElements.define('category-tile-small', CategoryTileSmall);

export { CategoryTileSmall };
